import Section from "../Section";
import KenBurns from '../global/KenBurns';

export default class ImageWithTextOverlay extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);
  }

  onSectionSelect = () => {
    this.kenBurns.reapply();
  }
}
